import { Route, Routes } from "react-router-dom";
import "./App.css";
import Home from "./Pages/Home";
import LoginPage from "./Pages/DashBoard/LoginPage/LoginPage";
import DefaultLayout from "./Components/Layout/DefaultLayout";
import AdminLayout from "./Components/Layout/AdminLayout";
import AddCertificate from "./Components/AdminDashboard/AddCertificate/AddCertificate";
import CertificateList from "./Components/AdminDashboard/CertificateList/CertificateList";
import Services from "./Pages/Services";
import Education from "./Pages/Education";
import Research from "./Pages/Research";
import AboutUs from "./Pages/AboutUs";
import Certificates from "./Pages/Certificates";
import ContactUs from "./Pages/ContactUs";
import Hologram from "./ServiceDetail/Hologram";
import Online from "./ServiceDetail/OnlineService";
import Sealing from "./ServiceDetail/SealingService";
import Certificate from "./Components/Certificate/Certificate";
import DiamondJewelryReports from "./Pages/CertificateDetails/DiamondJewelryReports";
import FancyDiamondReports from "./Pages/CertificateDetails/FancyDiamondReports";
import FullDiamondGradingReports from "./Pages/CertificateDetails/FullDiamondGradingReports";
import LabGrownReports from "./Pages/CertificateDetails/LabGrownReports";
import CertificateSummary from "./Certificate/CertificateSummary";
import Enquiries from "./Components/AdminDashboard/EnquiryList/EnquiryList";
import OurStore from "./OurStore/OurStore";

function App() {
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            <DefaultLayout>
              <Home />
            </DefaultLayout>
          }
        />
        <Route
          path="/about-us"
          element={
            <DefaultLayout>
              <AboutUs />
            </DefaultLayout>
          }
        />
        <Route
          path="/services"
          element={
            <DefaultLayout>
              <Services />
            </DefaultLayout>
          }
        />
        <Route
          path="/research"
          element={
            <DefaultLayout>
              <Research />
            </DefaultLayout>
          }
        />
        <Route
          path="/our-store"
          element={
            <DefaultLayout>
              <OurStore />
            </DefaultLayout>
          }
        />

        <Route
          path="/4cs-of-diamonds"
          element={
            <DefaultLayout>
              <Education />
            </DefaultLayout>
          }
        />
        {/* <Route path="/certificates"
          element={<DefaultLayout> <Certificates /></DefaultLayout>} /> */}
        <Route
          path="/diamond-hologram-stickers"
          element={
            <DefaultLayout>
              <Hologram />
            </DefaultLayout>
          }
        />
        <Route
          path="/online-certificate-verification"
          element={
            <DefaultLayout>
              <Online />
            </DefaultLayout>
          }
        />
        <Route
          path="/diamond-sealing-service"
          element={
            <DefaultLayout>
              <Sealing />
            </DefaultLayout>
          }
        />
        <Route
          path="/certificates"
          element={
            <DefaultLayout>
              <CertificateSummary />
            </DefaultLayout>
          }
        />

        <Route
          path="/diamond-jewelry-reports"
          element={
            <DefaultLayout>
              <DiamondJewelryReports />
            </DefaultLayout>
          }
        />
        <Route
          path="/fancy-diamond-reports"
          element={
            <DefaultLayout>
              <FancyDiamondReports />
            </DefaultLayout>
          }
        />
        <Route
          path="/full-diamond-grading-reports"
          element={
            <DefaultLayout>
              <FullDiamondGradingReports />
            </DefaultLayout>
          }
        />
        <Route
          path="/lab-grown-reports"
          element={
            <DefaultLayout>
              <LabGrownReports />
            </DefaultLayout>
          }
        />

        <Route
          path="/contact-us"
          element={
            <DefaultLayout>
              <ContactUs />
            </DefaultLayout>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/admin/addcertificate"
          element={
            <AdminLayout>
              <AddCertificate />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/certificatelist"
          element={
            <AdminLayout>
              <CertificateList />
            </AdminLayout>
          }
        />
        <Route
          path="/admin/enquirylist"
          element={
            <AdminLayout>
              <Enquiries />
            </AdminLayout>
          }
        />
      </Routes>
    </>
  );
}

export default App;
